import { toPairs } from 'lodash';
import styled from 'styled-components';
import { User } from 'api/models';
import { useGetAllActiveUsersMap } from 'hooks/use-idb';
import { Task } from 'stores/tasks';

export const AvatarList = styled.div<{ $color: string }>`
  position: absolute;
  bottom: 2px;
  right: 16px;

  > div {
    margin-top: var(--spacing-02);

    > a {
      color: ${({ $color }) => $color};
      display: inline-block;
      text-align: right;
      width: 24px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const useSortByCountGroupedArray = (
  data: Task[],
): {
  avatar: User;
  count: number;
}[] => {
  const users = useGetAllActiveUsersMap();

  return toPairs(
    data.reduce(
      (counts, task) =>
        (task.assignee ?? [])
          .filter(([type]) => type === 'user')
          .reduce(
            (task_counts, [, id]) => ({
              ...task_counts,
              [id]: (task_counts[id] ?? 0) + 1,
            }),
            counts,
          ),
      {} as Record<number, number>,
    ),
  )
    .sort(([, a], [, b]) => b - a)
    .slice(0, 2)
    .flatMap(([userId, count]) => {
      const avatar = users[parseInt(userId, 10)];

      if (avatar) {
        return [
          {
            avatar,
            count,
          },
        ];
      }

      return [];
    });
};
